import { RUNMODE } from "../constants/constants"

export const calculateGradient = () => {
  const sliderTrack = document.querySelectorAll(".slider-track")

  if (sliderTrack) {
    const sliderOne = document.querySelectorAll(".range1")
    const sliderTwo = document.querySelectorAll(".range2")

    sliderTrack.forEach((slider, index) => {
      const sliderMaxValue = parseInt(sliderOne[index].max)
      const sliderMinValue = parseInt(sliderOne[index].min)
      const sliderValueDifference = sliderMaxValue - sliderMinValue

      const v1 = parseInt(sliderOne[index]?.value) - sliderMinValue
      const v2 = parseInt(sliderTwo[index]?.value) - sliderMinValue

      const percent1 = (v1 / sliderValueDifference) * 100
      const percent2 = (v2 / sliderValueDifference) * 100

      slider.style.background = `linear-gradient(to right, rgba(0, 0, 0, 0.08) ${percent1}%, #0071BC ${percent1}%, #0071BC ${percent2}%, rgba(0, 0, 0, 0.08) ${percent2}%)`
    })
  }
}

export const replaceCharacterInString = (
  inputString,
  searchCharacter,
  replaceCharacter
) => {
  if (
    inputString == null ||
    searchCharacter == null ||
    replaceCharacter == null
  ) {
    // Handle null or undefined input
    return inputString
  }
  return inputString.split(searchCharacter).join(replaceCharacter)
}

export const getCurrentPage = (runMode) => {
  return window.location.pathname.includes("/topic") ? "topic" : "product"
}

export const hex2rgb = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
};